interface ErrorResponse {
    code: number;
    message: string;
}

export interface QuicktipTrackingState {
    quicktipTrackingeData: any;
    loading: boolean;
    quicktipTrackingeError: ErrorResponse | null;
}


export enum QuicktipTrackingActionTypes {
    FETCH_QUICKTIP_TRACKING_DATA = "FETCH_QUICKTIP_TRACKING_DATA",
    FETCH_QUICKTIP_TRACKING_DATA_SUCCESS = "FETCH_QUICKTIP_TRACKING_DATA_SUCCESS",
    FETCH_QUICKTIP_TRACKING_DATA_ERROR = "FETCH_QUICKTIP_TRACKING_DATA_ERROR",
}

export type QuicktipTrackingAction =
    | { type: QuicktipTrackingActionTypes.FETCH_QUICKTIP_TRACKING_DATA }
    | { type: QuicktipTrackingActionTypes.FETCH_QUICKTIP_TRACKING_DATA_SUCCESS; payload: any[] }
    | { type: QuicktipTrackingActionTypes.FETCH_QUICKTIP_TRACKING_DATA_ERROR; payload: any };